//GLOBAL - components from npm
import React, { useRef, useState, useEffect } from "react";
import { User } from "iconsax-reactjs";

//STYLES
import "./user-photo.css";

//COMPONENTS
import Typography from "../Typography";

//SERVICES - api, conectors...
import urlIngWeb from "../../actions/urlIngWeb";

//GLOBAL STATE - redux, env...

//ASSETS - icons, images...
import CLIENTE from "../../build/images/user.svg";

function UserPhoto({ link, size = "small", onClick, letterIcon = "" }) {
  //GENERAL
  const ref = useRef();

  //STATES
  const [imgLink, setImgLink] = useState(CLIENTE);

  //REDUX - Selectors

  //FUNCTIONS
  function renderProfileName(fullname) {
    // if() {
    fullname = fullname
      ? fullname.trim().replace(/\s(de|da|dos|das)\s/g, " ")
      : "";
    var start = fullname ? fullname.match(/\b(\w)/gi) : "";
    var name = fullname ? fullname.slice(0, 1).toUpperCase() : "";
    var surname = start
      ? start
          .splice(1, start.length - 1)
          .join("")
          .toUpperCase()
      : "";
    return name + surname.slice(0, 1);

    // } else {

    // }
  }

  //USE EFFECTS
  useEffect(() => {
    if (link) {
      if (link.includes("https")) {
        setImgLink(link);
      } else {
        setImgLink(urlIngWeb + link);
      }
    } else {
      setImgLink(CLIENTE);
    }
  }, [link]);

  return (
    <div className={`user-photo ${size}`} onClick={onClick}>
      {!letterIcon ? (
        <img src={imgLink} alt="" />
      ) : (
        <div className={`image-profile`}>
          {!isNaN(parseInt(letterIcon)) ? (
            // <img src={User} alt="" />
            <User color="#FFF" />
          ) : (
            <Typography.H4 weight="500" color="white">
              {renderProfileName(letterIcon)}
            </Typography.H4>
          )}
        </div>
      )}
    </div>
  );
}

export default UserPhoto;
